/* eslint-disable */

import Vue from 'vue'
import Component from 'vue-class-component';
import StepByStepConfig from '@/StepByStepConfig';
import VueScrollTo from 'vue-scrollto';
import date from 'date-and-time';

import { required, digits, email, max, regex } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

import priceHandler from '../libs/prices';
import { isSlotFree } from '@/libs/functions/isTimeSlotOverlapping';


setInteractionMode('eager')

extend('digits', {
    ...digits,
    message: '{_field_} muss mindestens {length} zeichen lang sein. ({_value_})',
})

extend('required', {
    ...required,
    message: '{_field_} muss gesetzt sein',
})

extend('max', {
    ...max,
    message: '{_field_} darf nicht größeer als {length} zeichen sein',
})

extend('regex', {
    ...regex,
    message: '{_field_} {_value_} entspricht nicht {regex}',
})

extend('email', {
    ...email,
    message: 'Email muss gültig sein',
})

@Component({
components: {
    ValidationProvider,
    ValidationObserver,
}
})
export default class StepByStepwView extends Vue {

public formfieldTyp = "";
public formfieldDuration = 0;
public formfieldPerson = 0;
public formfieldActivePerson = 0;
public formDate: any = null;
public formfieldSlot: any = null;
public formdata: any = {};
public stepByStepConfig = StepByStepConfig;
public bookings: any = [];
public valid = false;
public lineItems: any = [];
public error: string|null = null;

public showPersonInput = false;
private debounce: any;
private coupon: any = null;

public today = new Date();
public thisMonth = this.today.getMonth()+1;
public thisYear = this.today.getFullYear();

public studio: any; 

public formatPrice = priceHandler.formatPrice;

public async mounted(){

    this.formdata.checkboxes = {};

    // Find Type of Studio on init 
    const spaceId: string = this.$route.params.spaceid;
    if( this.$route.params.spaceid ){
        this.studio = this.stepByStepConfig.studios.find( (item: any) => item.spaceId == spaceId );
    }
    
    const fromTime = this.getFirstDayOfMonth(this.today.getFullYear(), this.today.getMonth() ).getTime();
    const toTime = this.today.getMonth() < 12 ? this.getFirstDayOfMonth(this.today.getFullYear(), this.today.getMonth()+1 ).getTime() : this.getFirstDayOfMonth(this.today.getFullYear()+1, 1 ).getTime();

    if( process.env.NODE_ENV === 'development' ) {
        this.bookings = ( await fetch(`http://localhost:7071/api/getEventsForStudio?space=${ this.$route.params.spaceid }&fromTime=${ fromTime }&toTime=${ toTime }`).then(res => res.json()) ).bookings;
    } else {
        this.bookings = ( await fetch(`/api/getEventsForStudio?space=${ this.$route.params.spaceid }&fromTime=${ fromTime }&toTime=${ toTime }`).then(res => res.json()) ).bookings;
    }

    //Make this better not as interval
    setInterval( this.generateLineItems, 1000 );

}

public scroll( element: string ){
    setTimeout( () => {
        VueScrollTo.scrollTo(element, 250, {})
    }, 250 );
}

public checkFormData( field: string, value: string ){
    console.log( this.formdata[ field ] == value )
    return this.formdata[ field ] == value;
}


getEvents (){
    return this.bookings.map( ( item: any ) => {
        item.name = `${ date.format( new Date( item.start ) , 'HH:mm' ) } bis ${ date.format( new Date( item.end ), 'HH:mm' ) }`;

        return item;
    });
}

getEventColor( e: any ) {
    return e.color;
}

public async refreshEvents(e:any) {
    let aDayInMs = 24 * 60 * 60 * 1000;

    if( process.env.NODE_ENV === 'development' ) {
        this.bookings = ( await fetch(`http://localhost:7071/api/getEventsForStudio?space=${ this.$route.params.spaceid }&fromTime=${ new Date( e.start.date ).getTime() }&toTime=${ new Date( e.end.date ).getTime() + aDayInMs }`).then(res => res.json()) ).bookings;
    } else {
        this.bookings = ( await fetch(`/api/getEventsForStudio?space=${ this.$route.params.spaceid }&fromTime=${ new Date( e.start.date ).getTime() }&toTime=${ new Date( e.end.date ).getTime() + aDayInMs }`).then(res => res.json()) ).bookings;
    }
}

public selectDate( e: any ){
    if( new Date(e.date).getTime() <= this.today.setHours(0,0,0) ){
        return;
    }

    console.log( e) ;
    this.formDate = e.date;
    this.scroll('#timestelect' );

}

public getType() {
    return this.studio.typ.find( (typ:any) => {
        return typ.name == this.formfieldTyp;
    });
}

public getSlotsForType() {
        const type = this.getType()

    if( this.getType() ){
        return type.slots;
    }

    return []
}

public getSlots(): any | [] {

    const type = this.getType();

    if( !type ){
        return []
    }

    //Get Subslots for Slot
    const slots = type.slots.find( ( i:any ) => {
        return i.hourVal == this.formfieldDuration
    })

    //const availSlots = slots?.subslots.filter( (slot:any) => {
    let availSlots = this.generateSubSlots( this.formfieldDuration ).filter( (slot:any) => {
        return isSlotFree(slot, this.formDate, this.bookings);
    })

    // Add meta like index and price
    const _type = this.getType();
    const _formfieldDuration = this.formfieldDuration;
    availSlots = availSlots.map( (val, index) => {
        val.index = index;

        const _slot = _type.slots.find( (slot:any) => {
            return slot.hourVal == _formfieldDuration;
        })
        console.log( _slot );
        val.price = _slot.price;

        return val;
    })

    console.log( availSlots );

    if( availSlots ){
        return availSlots;
    }


    return []; 
}

public getMaxUser() {
    if( this.getType().maxPersons ) {
        return this.getType().maxPersons.value;
    }

    return 8;
}

public getUserSelectList( start = 1) {
    let list = [];

    for( let i = start; i <= this.getMaxUser(); i++ ){
        list.push( i );
    }

    return list;
}

private generateSubSlots( duration = 2, minDistance = 1, startTime = "8:00", endTime = "22:00" ){
    let out: any[] =[];

    if( !duration ) return out;

    const startTimeHour = parseInt( startTime.split(':')[0] );
    const endTimeHour = parseInt( endTime.split(':')[0] );

    if( duration >= endTimeHour-startTimeHour ) {
        out.push({
            from: `${ startTimeHour }:00`, to: `${ endTimeHour }:00`
        })
    } else {
        for( let i = startTimeHour; i+duration <= endTimeHour; i = i + minDistance){
            out.push({
                from: `${ i }:00`, to: `${i + duration}:00`
            })            
        }
    }

    return out;
}

private daysInMonth (month: number, year: number ) {
    return new Date(year, month, 0).getDate();
}

private getFirstDayOfMonth (year: number, month: number) {
    return new Date(year, month, 1);
}

public save() {
        let postUrl;
        if( process.env.NODE_ENV === 'development' ) {
        postUrl = `http://localhost:7071/api/addBooking`;
        } else {
        postUrl =`/api/addBooking`
        }

        let body = this.lintModel( this.formdata );

        if( body.end == '' || body.start == '' ) {
        body = this.lintModel( this.formdata );
        }

        body.rawTimeData = {
        date: this.formDate,
        duration: this.formfieldDuration,
        timeFrom: this.formfieldSlot.from,
        timeTo: this.formfieldSlot.to
        }

        console.log( body );

        //Post via Fetch to API
        fetch(`${postUrl}`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => res.json()).then(res => {
            if (res.success ) {
                this.$router.push(`/thankyou`)
            } else {
                this.error = res.message;
            }
        });
    }

private lintModel(eventModel: any): any {

    let tempModel = eventModel;

    tempModel.start = new Date(`${ this.formDate } ${ this.formfieldSlot.from }`.replace(/-/g, "/") ).getTime();

    tempModel.end = new Date(`${ this.formDate } ${ this.formfieldSlot.from }`.replace(/-/g, "/") ).getTime() + ( this.formfieldDuration * 60 * 60 * 1000);

    if( !tempModel.space )
        tempModel.space = this.$route.params.spaceid;

    if( !tempModel['Art der Buchungsanfrage'])
        tempModel['Art der Buchungsanfrage'] = this.formfieldTyp;

    if( !tempModel.Personenzahl)
        tempModel.Personenzahl = this.formfieldPerson
    
    tempModel.priceLines = this.lineItems;
    tempModel.priceVat = this.getPriceTotal('vatOnly')
    tempModel.priceTotal = this.getPriceTotal();

    delete tempModel.color;
    delete tempModel.timed;
    delete tempModel.name;

    return tempModel;
}

public generateLineItems() {
    this.lineItems = [];

    // Add Base
    if( this.formfieldSlot && this.formfieldSlot.price  && this.formfieldDuration ){
        this.lineItems.push({
            description: 'Studio miete',
            price: this.formfieldSlot.price,
            meta: {
                duration: this.formfieldDuration,
            }
        });
    }

    if( this.formfieldTyp && this.formfieldActivePerson && this.formfieldDuration ){
        this.lineItems = priceHandler.addMoreActivePeople( this.lineItems, this.formfieldTyp, this.formfieldActivePerson, this.formfieldDuration );
    }

    if( this.getType() && this.formfieldPerson && this.formfieldDuration){
        this.lineItems = priceHandler.addBigGroups( this.lineItems, this.getType(), this.formfieldPerson, this.formfieldDuration );
    }

    if( this.formfieldTyp && this.formfieldPerson && this.formfieldDuration && this.formfieldTyp && this.formfieldActivePerson ){
        this.lineItems = priceHandler.addBigGroupsNew( this.lineItems, this.formfieldTyp, this.formfieldPerson, this.formfieldDuration, this.formfieldTyp, this.formfieldActivePerson );
    }

    if( this.coupon ){
        //If no valid is present OR if startTime is before validTime
        if( !this.coupon.validTill || (this.coupon.validTill * 1000) >= (new Date( `${ this.formDate } ${ this.formfieldSlot.from }`.replace(/-/g, "/") )).getTime() ) {
            this.lineItems = priceHandler.addCoupon( this.lineItems, this.coupon, this.lineItems[0].price, this.lineItems[0].meta.duration );
        } else {
            if( this.coupon.validTill && (this.coupon.validTill * 1000) >= (new Date( `${ this.formDate } ${ this.formfieldSlot.from }`.replace(/-/g, "/") )).getTime() ) {
                //Add Error message
                this.error = `Gutschein nur Gültig bis ${ new Date( this.coupon.validTill * 1000 ) }`;
            }
        }
    }

    // Conditioneller Rabatt       
        // 20% Rabatt
        if( this.formDate && this.formfieldSlot ){
            // Rabatt wenn Termin < 48 Std dann -20%
            // if date is less than 48 hours away then -20%
            let date = new Date( `${ this.formDate } ${ this.formfieldSlot.from }`.replace(/-/g, "/") );
            let now = new Date();
            let diff = date.getTime() - now.getTime();
            let diffHours = Math.round( diff / (1000 * 60 * 60) );
            if( diffHours < 48 ){
                this.lineItems.push({
                    description: 'Last Minute Tarif (-20%)',
                    price: -(this.getPriceTotal( 'noVat', (value:number) => { return value}) * 0.20),
                });
            } 
            // Nachtschwärmer Tarif
            else if( parseInt( this.formfieldSlot.from ) >= 18 && ( parseInt( this.formfieldSlot.to ) <= 6  || parseInt( this.formfieldSlot.to ) <= 24 )){
                this.lineItems.push({
                    description: 'Nachtschwärmer Tarif (-20%)',
                    price: -( this.getPriceTotal( 'noVat', (value:number) => { return value}) * 0.20),
                });
            }
        } 

}


public getPriceTotal(format = 'total', formater: any = priceHandler.formatPrice): any {
    return priceHandler.calculatePriceTotal( this.lineItems, this.getType().vat ? 19 : 0, format , formater);
}

public setFormFieldPerson( persons: number ) {
    this.formfieldPerson = persons;
    console.log( this.formfieldPerson );
}

public debounceFormfieldPerson(event : any) {
    
    clearTimeout(this.debounce)
    this.debounce = setTimeout(() => {
      this.setFormFieldPerson( parseInt( event.target.value ) );
    }, 600)
  }

switchToGewerblich() {
    this.formfieldTyp = 'Gewerblich';
    this.scroll('#timeslots');
    this.formfieldDuration = 0;
}

public async checkCode() {

    clearTimeout(this.debounce)
    this.debounce = setTimeout( async() => {
        let resp = null;
        if( process.env.NODE_ENV === 'development' ) {
            resp = await fetch(`http://localhost:7071/api/getCoupon?code=${ this.formdata.couponcode }`).then(res => res.json());
            resp.success ? this.coupon = resp.coupon : this.coupon = null;
        } else {
            resp = ( await fetch(`/api/getCoupon?code=${ this.formdata.couponcode }`).then(res => res.json()) );
            resp.success ? this.coupon = resp.coupon : this.coupon = null;
        }
    }, 500)

}

}